var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCalendarCheckPrimary({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar-check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.87171 1.33203C5.2399 1.33203 5.53838 1.63051 5.53838 1.9987V2.3606H10.9987V1.9987C10.9987 1.63051 11.2972 1.33203 11.6654 1.33203C12.0336 1.33203 12.332 1.63051 12.332 1.9987V2.44597C13.4919 2.74984 14.332 3.82813 14.332 5.0844L14.332 11.9416C14.332 13.4281 13.1557 14.6654 11.6654 14.6654H4.9987C3.50836 14.6654 2.33203 13.4281 2.33203 11.9416V5.0844C2.33203 3.87446 3.11138 2.82961 4.20505 2.48271V1.9987C4.20505 1.63051 4.50352 1.33203 4.87171 1.33203ZM4.9987 3.69393C4.27989 3.69393 3.66536 4.29864 3.66536 5.0844V5.27487H12.9987V5.0844C12.9987 4.29864 12.3842 3.69393 11.6654 3.69393H4.9987ZM12.9987 6.6082H3.66536V11.9416C3.66536 12.7273 4.27989 13.332 4.9987 13.332H11.6654C12.3842 13.332 12.9987 12.7273 12.9987 11.9416L12.9987 6.6082ZM10.4634 8.20641C10.7274 8.46307 10.7334 8.88514 10.4767 9.14913L8.14336 11.5491C8.01784 11.6782 7.84543 11.7511 7.66536 11.7511C7.4853 11.7511 7.31289 11.6782 7.18737 11.5491L6.18737 10.5205C5.93071 10.2566 5.93665 9.83449 6.20064 9.57784C6.46463 9.32118 6.8867 9.32712 7.14336 9.59111L7.66536 10.128L9.5207 8.21969C9.77736 7.9557 10.1994 7.94976 10.4634 8.20641Z",
    fill: "#4A5467"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalendarCheckPrimary);
export default __webpack_public_path__ + "static/media/ic-calendar-check-primary.f7f48adf829408446d16e5f3226f6534.svg";
export { ForwardRef as ReactComponent };